import React from 'react';
import { ActivityIndicator, View } from 'react-native';
import Text from '../Text';
import colors from '~/assets/themes/colors';

interface Props {
  visible: boolean;
  label?: string;
  children?: React.ReactNode;
}

const Loading = ({ visible, label, children }: Props) => {
  return (
    <>
      {visible && (
        <View className="absolute items-center justify-center bg-white w-[100%] h-[100%] z-50">
          <ActivityIndicator color={colors.primary[600]} size="large" />

          {!!label && (
            <Text className="text-base text-gray-500 mt-8">{label}</Text>
          )}
        </View>
      )}

      {children}
    </>
  );
};

export default Loading;
